/** Unwrap evaluate API body (some gateways nest under `data`). */
export function unwrapEvaluateResponse(res) {
  return res?.data?.data ?? res?.data;
}

/**
 * Merge GET .../assignment/responsibility/{id}/evaluate/ into assignment props
 * for ChecklistInspectionRightPane / ResponsibilityAssignmentDropDown.
 * @param {Record<string, unknown>} base
 * @param {unknown} evalData
 * @returns {Record<string, unknown>}
 */
export function mergeAssignmentWithEvaluate(base, evalData) {
  if (!evalData || typeof evalData !== "object" || Array.isArray(evalData)) {
    return base;
  }
  const extractCodeFromObj = (obj) => {
    if (!obj || typeof obj !== "object") return "";
    if (obj.code_str) {
      const s = String(obj.code_str);
      const m = s.match(/#?(\d+)/);
      if (m) return `#${m[1]}`;
      return s.startsWith("#") ? s : `#${s}`;
    }
    if (obj.code != null && obj.code !== "") {
      const c = String(obj.code);
      return c.startsWith("#") ? c : `#${c}`;
    }
    if (obj.id != null && obj.id !== "") return `#${obj.id}`;
    return "";
  };
  const out = { ...base };
  if (evalData.responsibility) {
    out.responsibilityCode = extractCodeFromObj(evalData.responsibility) || out.responsibilityCode;
    out.responsibilityName = evalData.responsibility.name || out.responsibilityName;
  }
  if (evalData.role) {
    out.roleCode = extractCodeFromObj(evalData.role) || out.roleCode;
    out.roleName = evalData.role.name || out.roleName;
  }
  if (evalData.position) {
    out.positionCode = extractCodeFromObj(evalData.position) || out.positionCode;
    out.positionName = evalData.position.name || out.positionName;
  }
  return out;
}
